import React from 'react'
import { Table, Button, Space, Tag, Image } from 'antd'
import { EditOutlined, DeleteOutlined } from '@ant-design/icons'
import type { Promotion } from '../types/promotion.types'
import { DocumentImage } from '../../../shared/components/DocumentImage'

interface PromotionsTableProps {
    promotions: Promotion[]
    onEdit: (promotion: Promotion) => void
    onDelete: (promotion: Promotion) => void
}

export const PromotionsTable: React.FC<PromotionsTableProps> = ({ promotions, onEdit, onDelete }) => {
    const columns = [
        {
            title: 'Banner',
            dataIndex: 'image_url_resolved',
            key: 'image_url_resolved',
            width: 120,
            render: (url: string) => (
                <DocumentImage
                    documentId={url}
                    alt="Banner"
                    width={100}
                    height={60}
                    style={{ objectFit: 'cover', borderRadius: 4, cursor: 'pointer' }}
                    fallbackUrl="https://via.placeholder.com/100x60?text=No+Image"
                    preview={{
                        src: url,
                        mask: 'Preview'
                    }}
                />
            ),
        },
        {
            title: 'Title',
            dataIndex: 'title',
            key: 'title',
            sorter: (a: Promotion, b: Promotion) => a.title.localeCompare(b.title),
        },
        {
            title: 'Subtitle',
            dataIndex: 'subtitle',
            key: 'subtitle',
            ellipsis: true,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: 100,
            render: (status: string) => (
                <Tag color={status === 'active' ? 'green' : 'default'}>
                    {status?.toUpperCase()}
                </Tag>
            ),
        },
        {
            title: 'Actions',
            key: 'actions',
            width: 120,
            render: (_: any, record: Promotion) => (
                <Space size="small">
                    <Button size="small" icon={<EditOutlined />} onClick={() => onEdit(record)} />
                    <Button size="small" icon={<DeleteOutlined />} danger onClick={() => onDelete(record)} />
                </Space>
            ),
        },
    ]

    return (
        <Table
            columns={columns}
            dataSource={promotions}
            rowKey="id"
            pagination={{ pageSize: 10 }}
        />
    )
}
